import { useState } from "react";
import { signUpUser } from "../../services/loginservices/LoginAPIservice";

export default function SignUpPage({ onClose, onSignUpSuccess }) {
  const [username, setUsername] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null); // "success" | "error" | null
  const [statusMessage, setStatusMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setStatusMessage("");
    setIsLoading(true);

    const payload = {
      username: username.trim(),
      email: email.trim(),
      password,
      user_role: "C",
    };

    try {
      const data = await signUpUser(payload);

      if (data?.message) {
        setStatus("success");
        setStatusMessage("Sign up successful!");
        setTimeout(() => {
          onSignUpSuccess?.();
          onClose?.();
        }, 1500);
      } else {
        setStatus("error");
        setStatusMessage("Contact support team for create user.");
      }
    } catch (err) {
      setStatus("error");
      setStatusMessage("Contact support team for create user.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white w-full max-w-sm p-6 rounded-lg shadow-lg">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-lg font-semibold">SIGN UP</h2>
          <button
            onClick={onClose}
            className="text-gray-600 hover:text-gray-900 text-xl"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        {status === "success" ? (
          <div className="py-4 text-center">
            <p className="text-green-600 font-medium">{statusMessage}</p>
            <p className="text-sm text-gray-500 mt-2">Redirecting to Sign In...</p>
          </div>
        ) : (
          <>
            <p className="text-sm text-gray-700 mb-4">
              Create an account to explore all features.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Username
                </label>
                <input
                  type="text"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  placeholder="e.g. john_doe"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                  required
                  placeholder="e.g. john@example.com"
                />
              </div>

              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Password
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-red-500"
                  placeholder="••••••••"
                  required
                />
              </div>

              {status === "error" && (
                <p className="text-red-500 text-sm mb-4">{statusMessage}</p>
              )}

              <button
                type="submit"
                disabled={isLoading}
                className="w-full py-3 bg-black text-white font-semibold rounded-md hover:bg-gray-800 transition-colors disabled:opacity-50"
              >
                {isLoading ? "Creating..." : "CREATE"}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
